/** Local cache for National Identity auto-verify failures (reject ×2 → 3rd pending). */

const PREFIX = 'kyc_verify_fail_count_';

function storageKey(userId) {
  return `${PREFIX}${String(userId || '').trim() || 'anon'}`;
}

export function getKycVerifyFailCount(userId) {
  if (typeof localStorage === 'undefined') return 0;
  try {
    const raw = localStorage.getItem(storageKey(userId));
    const n = Number.parseInt(raw ?? '0', 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function setKycVerifyFailCount(userId, count) {
  if (typeof localStorage === 'undefined') return;
  try {
    const n = Math.max(0, Number(count) || 0);
    if (n <= 0) localStorage.removeItem(storageKey(userId));
    else localStorage.setItem(storageKey(userId), String(n));
  } catch {
    /* private mode / quota */
  }
}

export function clearKycVerifyFailCount(userId) {
  setKycVerifyFailCount(userId, 0);
}

/** After a failed verify response, store the attempt number from the API. */
export function recordKycVerifyFailure(userId, failedAttemptNumber) {
  const n = Number(failedAttemptNumber);
  if (Number.isFinite(n) && n > 0) {
    setKycVerifyFailCount(userId, n);
    return n;
  }
  const next = getKycVerifyFailCount(userId) + 1;
  setKycVerifyFailCount(userId, next);
  return next;
}

export function kycCacheUserId(userData) {
  return (
    userData?.affiliateUserId ??
    userData?.AffiliateUserId ??
    userData?.userId ??
    userData?.UserId ??
    userData?.id ??
    ''
  );
}
